import { makeStyles } from '@material-ui/core/styles';
import { calculateHeight, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface PassedProps {
  selected: boolean;
}

export const styles = makeStyles(theme => ({
  categoryButtonContainerItem: {
    width: '100%',
    padding: '0',
    marginBottom: calculateHeight(10).stringValue,
  },
  categoryButtonRoot: ({ selected }: PassedProps) => ({
    fontSize: vh(2.08),
    border: selected
      ? `2px solid ${theme.palette.secondary.main} !important`
      : `1px solid ${themeColor.secondaryLight}`,
  }),
}));
